"use strict";
'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getInputValueAsString = getInputValueAsString;
exports.useNumberInput = useNumberInput;
var _formatMuiErrorMessage2 = _interopRequireDefault(require("@mui/utils/formatMuiErrorMessage"));
var React = _interopRequireWildcard(require("react"));
var _utils = require("@mui/utils");
var _extractEventHandlers = require("../utils/extractEventHandlers");
var _useControllableReducer = require("../utils/useControllableReducer");
var _FormControl = require("../FormControl");
var _numberInputAction = require("./numberInputAction.types");
var _numberInputReducer = require("./numberInputReducer");
var _utils2 = require("./utils");
var STEP_KEYS = [
    'ArrowUp',
    'ArrowDown',
    'PageUp',
    'PageDown'
];
var SUPPORTED_KEYS = _to_consumable_array(STEP_KEYS).concat([
    'Home',
    'End'
]);
function getInputValueAsString(v) {
    return v ? String(v.trim()) : String(v);
}
/**
 *
 * Demos:
 *
 * - [Number Input](https://mui.com/base-ui/react-number-input/#hook)
 *
 * API:
 *
 * - [useNumberInput API](https://mui.com/base-ui/react-number-input/hooks-api/#use-number-input)
 */ function useNumberInput(parameters) {
    var min = parameters.min, max = parameters.max, step = parameters.step, _parameters_shiftMultiplier = parameters.shiftMultiplier, shiftMultiplier = _parameters_shiftMultiplier === void 0 ? 10 : _parameters_shiftMultiplier, defaultValueProp = parameters.defaultValue, tmp = parameters.disabled, disabledProp = tmp === void 0 ? false : tmp, tmp1 = parameters.error, errorProp = tmp1 === void 0 ? false : tmp1, onBlur = parameters.onBlur, onInputChange = parameters.onInputChange, onFocus = parameters.onFocus, onChange = parameters.onChange, tmp2 = parameters.required, requiredProp = tmp2 === void 0 ? false : tmp2, tmp3 = parameters.readOnly, readOnlyProp = tmp3 === void 0 ? false : tmp3, valueProp = parameters.value, inputRefProp = parameters.inputRef, inputIdProp = parameters.inputId, _parameters_componentName = parameters.componentName, componentName = _parameters_componentName === void 0 ? 'useNumberInput' : _parameters_componentName;
    // TODO: make it work with FormControl
    var formControlContext = (0, _FormControl.useFormControlContext)();
    var _React_useRef = React.useRef(valueProp != null), isControlled = _React_useRef.current;
    var handleInputRefWarning = React.useCallback(function(instance) {
        if (process.env.NODE_ENV !== 'production') {
            if (instance && instance.nodeName !== 'INPUT' && !instance.focus) {
                console.error([
                    'MUI: You have provided a `slots.input` to the input component',
                    'that does not correctly handle the `ref` prop.',
                    'Make sure the `ref` prop is called with a HTMLInputElement.'
                ].join('\n'));
            }
        }
    }, []);
    var inputRef = React.useRef(null);
    var handleInputRef = (0, _utils.unstable_useForkRef)(inputRef, inputRefProp, handleInputRefWarning);
    var inputId = (0, _utils.unstable_useId)(inputIdProp);
    var _React_useState = _sliced_to_array(React.useState(false), 2), focused = _React_useState[0], setFocused = _React_useState[1];
    var handleStateChange = React.useCallback(function(event, field, fieldValue, reason) {
        if (field === 'value' && typeof fieldValue !== 'string') {
            switch(reason){
                // only a blur event will dispatch `numberInput:clamp`
                case 'numberInput:clamp':
                    onChange === null || onChange === void 0 ? void 0 : onChange(event, fieldValue);
                    break;
                case 'numberInput:increment':
                case 'numberInput:decrement':
                case 'numberInput:incrementToMax':
                case 'numberInput:decrementToMin':
                    onChange === null || onChange === void 0 ? void 0 : onChange(event, fieldValue);
                    break;
                default:
                    break;
            }
        }
    }, [
        onChange
    ]);
    var numberInputActionContext = React.useMemo(function() {
        return {
            min: min,
            max: max,
            step: step,
            shiftMultiplier: shiftMultiplier,
            getInputValueAsString: getInputValueAsString
        };
    }, [
        min,
        max,
        step,
        shiftMultiplier
    ]);
    var _ref;
    var initialValue = (_ref = valueProp !== null && valueProp !== void 0 ? valueProp : defaultValueProp) !== null && _ref !== void 0 ? _ref : null;
    var initialState = {
        value: initialValue,
        inputValue: initialValue ? String(initialValue) : ''
    };
    var controlledState = React.useMemo(function() {
        return {
            value: valueProp
        };
    }, [
        valueProp
    ]);
    var _ref1 = _sliced_to_array((0, _useControllableReducer.useControllableReducer)({
        reducer: _numberInputReducer.numberInputReducer,
        controlledProps: controlledState,
        initialState: initialState,
        onStateChange: handleStateChange,
        actionContext: React.useMemo(function() {
            return numberInputActionContext;
        }, [
            numberInputActionContext
        ]),
        componentName: componentName
    }), 2), state = _ref1[0], dispatch = _ref1[1];
    var value = state.value, inputValue = state.inputValue;
    React.useEffect(function() {
        if (!formControlContext && disabledProp && focused) {
            setFocused(false);
            onBlur === null || onBlur === void 0 ? void 0 : onBlur();
        }
    }, [
        formControlContext,
        disabledProp,
        focused,
        onBlur
    ]);
    React.useEffect(function() {
        if (isControlled && (0, _utils2.isNumber)(value)) {
            dispatch({
                type: _numberInputAction.NumberInputActionTypes.resetInputValue
            });
        }
    }, [
        value,
        dispatch,
        isControlled
    ]);
    var createHandleFocus = function(otherHandlers) {
        return function(event) {
            var _otherHandlers_onFocus;
            (_otherHandlers_onFocus = otherHandlers.onFocus) === null || _otherHandlers_onFocus === void 0 ? void 0 : _otherHandlers_onFocus.call(otherHandlers, event);
            if (event.defaultMuiPrevented || event.defaultPrevented) {
                return;
            }
            if (formControlContext && formControlContext.onFocus) {
                var _formControlContext_onFocus;
                formControlContext === null || formControlContext === void 0 ? void 0 : (_formControlContext_onFocus = formControlContext.onFocus) === null || _formControlContext_onFocus === void 0 ? void 0 : _formControlContext_onFocus.call(formControlContext);
            }
            setFocused(true);
        };
    };
    var createHandleInputChange = function(otherHandlers) {
        return function(event) {
            var _formControlContext_onChange, _otherHandlers_onInputChange;
            if (!isControlled && event.target === null) {
                throw new Error(process.env.NODE_ENV !== "production" ? 'MUI: Expected valid input target. ' + 'Did you use a custom `slots.input` and forget to forward refs? ' + 'See https://mui.com/r/input-component-ref-interface for more info.' : (0, _formatMuiErrorMessage2.default)(17));
            }
            formControlContext === null || formControlContext === void 0 ? void 0 : (_formControlContext_onChange = formControlContext.onChange) === null || _formControlContext_onChange === void 0 ? void 0 : _formControlContext_onChange.call(formControlContext, event);
            (_otherHandlers_onInputChange = otherHandlers.onInputChange) === null || _otherHandlers_onInputChange === void 0 ? void 0 : _otherHandlers_onInputChange.call(otherHandlers, event);
            if (event.defaultMuiPrevented || event.defaultPrevented) {
                return;
            }
            dispatch({
                type: _numberInputAction.NumberInputActionTypes.inputChange,
                event: event,
                inputValue: event.currentTarget.value
            });
        };
    };
    var createHandleBlur = function(otherHandlers) {
        return function(event) {
            var _otherHandlers_onBlur;
            formControlContext === null || formControlContext === void 0 ? void 0 : formControlContext.onBlur();
            (_otherHandlers_onBlur = otherHandlers.onBlur) === null || _otherHandlers_onBlur === void 0 ? void 0 : _otherHandlers_onBlur.call(otherHandlers, event);
            if (event.defaultMuiPrevented || event.defaultPrevented) {
                return;
            }
            dispatch({
                type: _numberInputAction.NumberInputActionTypes.clamp,
                event: event,
                inputValue: event.currentTarget.value
            });
            setFocused(false);
        };
    };
    var createHandleClick = function(otherHandlers) {
        return function(event) {
            var _otherHandlers_onClick;
            (_otherHandlers_onClick = otherHandlers.onClick) === null || _otherHandlers_onClick === void 0 ? void 0 : _otherHandlers_onClick.call(otherHandlers, event);
            if (event.defaultMuiPrevented || event.defaultPrevented) {
                return;
            }
            if (inputRef.current && event.currentTarget === event.target) {
                inputRef.current.focus();
            }
        };
    };
    var handleStep = function(direction) {
        return function(event) {
            var applyMultiplier = Boolean(event.shiftKey);
            var actionType = {
                up: _numberInputAction.NumberInputActionTypes.increment,
                down: _numberInputAction.NumberInputActionTypes.decrement
            }[direction];
            dispatch({
                type: actionType,
                event: event,
                applyMultiplier: applyMultiplier
            });
        };
    };
    var createHandleKeyDown = function(otherHandlers) {
        return function(event) {
            var _otherHandlers_onKeyDown;
            (_otherHandlers_onKeyDown = otherHandlers.onKeyDown) === null || _otherHandlers_onKeyDown === void 0 ? void 0 : _otherHandlers_onKeyDown.call(otherHandlers, event);
            if (event.defaultMuiPrevented || event.defaultPrevented) {
                return;
            }
            // this prevents unintended page scrolling
            if (SUPPORTED_KEYS.includes(event.key)) {
                event.preventDefault();
            }
            switch(event.key){
                case 'ArrowUp':
                    dispatch({
                        type: _numberInputAction.NumberInputActionTypes.increment,
                        event: event,
                        applyMultiplier: !!event.shiftKey
                    });
                    break;
                case 'ArrowDown':
                    dispatch({
                        type: _numberInputAction.NumberInputActionTypes.decrement,
                        event: event,
                        applyMultiplier: !!event.shiftKey
                    });
                    break;
                case 'PageUp':
                    dispatch({
                        type: _numberInputAction.NumberInputActionTypes.increment,
                        event: event,
                        applyMultiplier: true
                    });
                    break;
                case 'PageDown':
                    dispatch({
                        type: _numberInputAction.NumberInputActionTypes.decrement,
                        event: event,
                        applyMultiplier: true
                    });
                    break;
                case 'Home':
                    dispatch({
                        type: _numberInputAction.NumberInputActionTypes.incrementToMax,
                        event: event
                    });
                    break;
                case 'End':
                    dispatch({
                        type: _numberInputAction.NumberInputActionTypes.decrementToMin,
                        event: event
                    });
                    break;
                default:
                    break;
            }
        };
    };
    var getRootProps = function() {
        var externalProps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var propsEventHandlers = (0, _extractEventHandlers.extractEventHandlers)(parameters, [
            // these are handled by the input slot
            'onBlur',
            'onInputChange',
            'onFocus',
            'onChange'
        ]);
        var externalEventHandlers = _object_spread({}, propsEventHandlers, (0, _extractEventHandlers.extractEventHandlers)(externalProps));
        return _object_spread_props(_object_spread({}, externalProps, externalEventHandlers), {
            onClick: createHandleClick(externalEventHandlers)
        });
    };
    var getInputProps = function() {
        var externalProps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var propsEventHandlers = {
            onBlur: onBlur,
            onFocus: onFocus,
            // onChange from normal props is the custom onChange so we ignore it here
            onChange: onInputChange
        };
        var externalEventHandlers = _object_spread({}, propsEventHandlers, (0, _extractEventHandlers.extractEventHandlers)(externalProps, [
            // onClick is handled by the root slot
            'onClick'
        ]));
        var mergedEventHandlers = _object_spread_props(_object_spread({}, externalEventHandlers), {
            onFocus: createHandleFocus(externalEventHandlers),
            // slotProps.onChange is renamed to onInputChange and passed to createHandleInputChange
            onChange: createHandleInputChange(_object_spread_props(_object_spread({}, externalEventHandlers), {
                onInputChange: externalEventHandlers.onChange
            })),
            onBlur: createHandleBlur(externalEventHandlers),
            onKeyDown: createHandleKeyDown(externalEventHandlers)
        });
        var _ref;
        var displayValue = (_ref = focused ? inputValue : value) !== null && _ref !== void 0 ? _ref : '';
        // get rid of slotProps.input.onInputChange before returning to prevent it from entering the DOM
        // if it was passed, it will be in mergedEventHandlers and throw
        delete externalProps.onInputChange;
        return _object_spread(_object_spread_props(_object_spread({
            type: 'text',
            id: inputId,
            'aria-invalid': errorProp || undefined,
            defaultValue: undefined,
            value: displayValue,
            'aria-valuenow': displayValue,
            'aria-valuetext': String(displayValue),
            'aria-valuemin': min,
            'aria-valuemax': max,
            autoComplete: 'off',
            autoCorrect: 'off',
            spellCheck: 'false',
            required: requiredProp,
            readOnly: readOnlyProp,
            'aria-disabled': disabledProp,
            disabled: disabledProp
        }, externalProps), {
            ref: handleInputRef
        }), mergedEventHandlers);
    };
    var handleStepperButtonMouseDown = function(event) {
        event.preventDefault();
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };
    var stepperButtonCommonProps = {
        'aria-controls': inputId,
        tabIndex: -1
    };
    var isIncrementDisabled = disabledProp || ((0, _utils2.isNumber)(value) ? value >= (max !== null && max !== void 0 ? max : Number.MAX_SAFE_INTEGER) : false);
    var getIncrementButtonProps = function() {
        var externalProps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return _object_spread_props(_object_spread({}, externalProps, stepperButtonCommonProps), {
            disabled: isIncrementDisabled,
            'aria-disabled': isIncrementDisabled,
            onMouseDown: handleStepperButtonMouseDown,
            onClick: handleStep('up')
        });
    };
    var isDecrementDisabled = disabledProp || ((0, _utils2.isNumber)(value) ? value <= (min !== null && min !== void 0 ? min : Number.MIN_SAFE_INTEGER) : false);
    var getDecrementButtonProps = function() {
        var externalProps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return _object_spread_props(_object_spread({}, externalProps, stepperButtonCommonProps), {
            disabled: isDecrementDisabled,
            'aria-disabled': isDecrementDisabled,
            onMouseDown: handleStepperButtonMouseDown,
            onClick: handleStep('down')
        });
    };
    return {
        disabled: disabledProp,
        error: errorProp,
        focused: focused,
        formControlContext: formControlContext,
        getInputProps: getInputProps,
        getIncrementButtonProps: getIncrementButtonProps,
        getDecrementButtonProps: getDecrementButtonProps,
        getRootProps: getRootProps,
        required: requiredProp,
        value: value,
        inputValue: inputValue,
        isIncrementDisabled: isIncrementDisabled,
        isDecrementDisabled: isDecrementDisabled
    };
}
